module.exports = {
  email: 'asela1madusanka@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/aselamadusanka',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/__asela_',
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/__asela_',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/aselamadusanka',
    },
    {
      name: 'Facebook',
      url: 'https://web.facebook.com/asela1madusanka',
    },
    {
      name: 'WhatsApp',
      url: 'https://wa.me/+94769935272',
    },
    {
      name: 'Telegram',
      url: 'https://t.me/a_s_e_l_a_madusanka',
    },
    {
      name: 'Threads',
      url: 'https://www.threads.net/@__asela_',
    },
//    {
//      name: 'YouTube',
//      url: 'https://www.youtube.com/@_aselamadusanka',
//    },
    {
      name: 'TikTok',
      url: 'https://www.tiktok.com/@__asela_',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Studies',
      url: '/#educations',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
